import { render } from "./EditTable.vue?vue&type=template&id=6145de08"
import script from "./EditTable.vue?vue&type=script&lang=js"
export * from "./EditTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__